'use strict';

window.jQuery = window.$ = require('jquery');
